(function () {
    'use strict';

    angular
        .module('app.hbIntegration')
        .controller('HBMatchCategoryFilterListController', HBMatchCategoryFilterListController);

    HBMatchCategoryFilterListController.$inject = ['$location', '$stateParams', 'HBIntegrationService', 'NgTableParams', '$uibModal'];

    function HBMatchCategoryFilterListController($location, $stateParams, HBIntegrationService, NgTableParams, $uibModal) {
        /* jshint validthis:true */
        var vm = this;
        vm.settings = globalSettings;
        activate();
        function activate() {
            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function () {
                        return HBIntegrationService.hbgetMatchCategoryFilterListByCategory($stateParams.Id).then(function (data) {
                            
                            return data;
                        });
                    }
                });
        }
    }
})();